module.exports = __webpack_public_path__ + "img/5-1.1ce7e238.svg";